import { render, staticRenderFns } from "./TxtIcon.vue?vue&type=template&id=3b0974fa&"
import script from "./TxtIcon.vue?vue&type=script&lang=js&"
export * from "./TxtIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports